// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"837c6e51","703":"2bc43c01","787":"3b8b3d58"}[chunkId] + ".chunk.js";
};